import React, { useContext } from 'react';
import LocaleContext from 'contexts/locale-context';

const CustomSearchField = (props) => {
    const { translations } = useContext(LocaleContext);

    return (
        <div className="bp3-input-group">
            <span className="bp3-icon bp3-icon-search"></span>
            <input className="bp3-input" type="search" placeholder={translations.js.search_input} dir="auto" {...props}/>
        </div>
    );
}

export default CustomSearchField;